import React, { useEffect, useState } from "react";
import { flagsApi, formatErr } from "./api";
import { Breadcrumbs } from "./AdminLayout";
import { toast, Toaster } from "sonner";

export default function AdminFlags() {
  const [flags, setFlags] = useState([]);
  const load = () => flagsApi.list().then(setFlags).catch(()=>{});
  useEffect(() => { load(); }, []);

  const toggle = async (key, current) => {
    try { await flagsApi.update(key, !current); toast.success(`${key} → ${!current}`); load(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-flags">
      <Toaster richColors position="top-right"/>
      <Breadcrumbs items={["Admin", "Feature Flags"]}/>
      <h1 className="font-serif text-3xl text-navy tracking-tight">Feature Flags</h1>
      <p className="text-stone2 text-sm mt-1">Hidden capabilities remain non-indexable until enabled here.</p>
      <div className="mt-8 bg-white border border-line divide-y divide-line">
        {flags.map(f => (
          <div key={f.key} data-testid={`flag-${f.key}`} className="p-5 flex items-center justify-between gap-4">
            <div>
              <div className="mono text-xs text-navy">{f.key}</div>
              <div className="text-sm text-stone2 mt-1">{f.description}</div>
            </div>
            <button data-testid={`toggle-${f.key}`} onClick={()=>toggle(f.key, f.value)}
              className={`text-xs mono uppercase tracking-widest px-4 py-2 border ${f.value ? "bg-navy text-white border-navy" : "border-line text-stone2 hover:border-navy hover:text-navy"}`}>
              {f.value ? "ENABLED" : "DISABLED"}
            </button>
          </div>
        ))}
        {flags.length === 0 && <div className="p-6 text-stone2">No flags yet.</div>}
      </div>
    </div>
  );
}
